import React from 'react';
import { useIntl } from 'react-intl';

import { CertificateItemTag } from '../../../components/certificate-card/components';

import type { DetailTagsRowProps } from './types';

import styles from './styles.module.scss';

export const DetailTagsRow: React.FC<DetailTagsRowProps> = ({ items = [] }) => {
  const intl = useIntl();

  if (!items?.length) {
    return <></>;
  }
  return (
    <div
      className={styles.tagsRow}
      role="group"
      aria-label={intl.formatMessage({ id: 'certificates.detail.tagsGroupAria' })}
    >
      {items.map((item) => (
        <CertificateItemTag key={item.id} item={item} />
      ))}
    </div>
  );
};
